import {useSyncExternalStore} from 'react';

let activeCMSBranchId: string | null = null;
const listeners = new Set<() => void>();

/**
 * The CMS branch the Designer reads and writes CMS items on, or null for main.
 * Set from the active site branch by `setCMSBranchId`.
 */
export function getCMSBranchId(): string | null {
  return activeCMSBranchId;
}

/**
 * Called by the Designer whenever the active site branch's CMS branch id
 * changes, so CMS clients outside Flux read the same value.
 */
export function setCMSBranchId(cmsBranchId: string | null): void {
  if (cmsBranchId === activeCMSBranchId) {
    return;
  }
  activeCMSBranchId = cmsBranchId;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * `getCMSBranchId` for hooks: re-renders on a branch switch, so query keys
 * built from the branch pick up the new one.
 */
export function useCMSBranchId(): string | null {
  return useSyncExternalStore(subscribe, getCMSBranchId);
}
